module.exports = __webpack_public_path__ + "img/dapitan.aabec64b.jpg";